<template>
  <el-dialog
    custom-class="custom-dialog"
    :visible.sync="visible"
    ref="dialog"
    title="信息补全"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    @close="hide"
  >
    <p class="tip">
      为了给您提供更好的服务，并确保课程证书能够顺利颁发，请完善以下信息
    </p>
    <el-form
      :model="formModel"
      :rules="rules"
      ref="formRef"
      label-width="120px"
      label-position="left"
    >
      <el-form-item label="姓名" prop="realname">
        <el-input v-model="formModel.realname" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="证件号" prop="idcardType">
        <el-select v-model="formModel.idcardType" placeholder="请选择">
          <el-option
            v-for="item in idcardTypes"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          ></el-option>
        </el-select>

        <el-form-item style="display: inline-block" prop="idcardNo">
          <el-input
            v-model="formModel.idcardNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form-item>
      <el-form-item
        label="地区"
        prop="provinceId"
        :rules="{ required: true, message: '省份不能为空' }"
      >
        <el-select
          v-model="formModel.provinceId"
          placeholder="请选择"
          @change="onProvinceChange"
        >
          <el-option
            v-for="province in provinces"
            :label="province.areaName"
            :key="province.id"
            :value="province.id"
          ></el-option>
        </el-select>
        <el-form-item
          prop="cityId"
          style="display: inline-block"
          :rules="{ required: true, message: '城市不能为空' }"
        >
          <el-select
            v-model="formModel.cityId"
            placeholder="请选择"
            @change="onCityChange"
          >
            <el-option
              v-for="province in cityies"
              :label="province.areaName"
              :key="province.id"
              :value="province.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="districtId"
          style="display: inline-block"
          :rules="{ required: true, message: '区县不能为空' }"
        >
          <el-select v-model="formModel.districtId" placeholder="请选择">
            <el-option
              v-for="province in districts"
              :label="province.areaName"
              :key="province.id"
              :value="province.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item prop="schoolTitle" label="学校（单位）">
        <el-input
          v-model="formModel.schoolTitle"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份" required prop="identityType">
        <el-radio-group v-model="formModel.identityType">
          <el-radio
            v-for="item in identityTypes"
            :key="item.dictValue"
            :label="item.dictValue"
          >
            {{ item.dictLabel }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="formModel.identityType === '0'" label="学段"  required prop="gradeType">
        <el-radio-group v-model="formModel.gradeType">
          <el-radio
            v-for="item in gradeTypes"
            :key="item.dictValue"
            :label="item.dictValue"
          >
            {{ item.dictLabel }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" @click="onSave"> 提交信息 </el-button>
        <p>信息一旦提交不可修改，请仔细核对</p>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { getUserInfo, updateUserInfo } from "@/api/user";
import { getDicts } from "@/api";
import { getProvince, getCity, getDistrict } from "@/api/common";

export default {
  name: "InformationSupplementDialog",
  data() {
    return {
      visible: false,
      formModel: {
        realname: "",
        idcardNo: "",
        idcardType: "",
        schoolTitle: "",
        gradeType: "",
        identityType: "",
        provinceId: "",
        cityId: "",
        districtId: "",
      },
      rules: {
        realname: [{ required: true, message: "姓名不能为空" }],
        idcardNo: [{ required: true, message: "证件号不能为空" }],
        idcardType: [{ required: true, message: "证件类型不能为空" }],
        area: [{ required: true, message: "地区不能为空" }],
        schoolTitle: [{ required: true, message: "学校单位不能为空" }],
        gradeType: [{ required: true, message: "学段不能为空" }],
        identityType: [{ required: true, message: "身份不能为空" }],
      },
      idcardTypes: [],
      provinces: [],
      cityies: [],
      districts: [],
      userId: "",
      identityTypes: [],
      gradeTypes: [],
    };
  },

  created() {
    getDicts("certificate_type").then((response) => {
      this.idcardTypes = response.data;
    });
    getDicts("user_identity_type").then((response) => {
      this.identityTypes = response.data;
    });
    getDicts("user_grade_type").then((response) => {
      this.gradeTypes = response.data;
    });

    this.getProvince();
  },
  methods: {
    onProvinceChange(provinceId) {
      this.formModel.cityId = "";
      this.formModel.districtId = "";
      this.getCity(provinceId);
    },
    onCityChange(cityId) {
      this.formModel.districtId = "";
      this.getDistrict(cityId);
    },
    getProvince() {
      getProvince().then(({ data }) => {
        this.provinces = data;
      });
    },
    getCity(provinceId) {
      getCity(provinceId).then(({ data }) => {
        this.cityies = data;
      });
    },
    getDistrict(cityId) {
      getDistrict(cityId).then(({ data }) => {
        this.districts = data;
      });
    },
    show() {
      this.visible = true;

      getUserInfo().then(({ data }) => {
        this.userId = data.id;
      });
    },
    hide() {
      this.visible = false;
      this.$refs.formRef.resetFields();
    },
    onSave() {
      this.$refs.formRef.validate(async (res) => {
        if (!res) return;

        await updateUserInfo({ ...this.formModel, id: this.userId });
        this.hide();
        this.$emit("success");
      });
    },
  },
};
</script>

<style lang="scss">
.custom-dialog {
  &.el-dialog {
    background: #171f30;
    border: 1px solid #046bde;
  }

  .el-dialog__header {
    padding: 60px 60px 20px 60px;
  }

  .el-dialog__title {
    font-weight: 600;
    font-size: 30px;
    color: #ffffff;
  }

  .el-dialog__body {
    padding: 0 60px 60px 60px;
  }

  .tip {
    font-weight: 400;
    font-size: 14px;
    color: #788a9f;
    margin-bottom: 20px;
  }

  .el-select {
    &:hover {
      .el-input__inner {
        border-color: #046bde;
      }
    }
  }

  .el-input__inner {
    background-color: transparent;
    border: 1px solid #046bde;
    border-radius: 20px;
    color: #fff;

    &::placeholder {
      color: #909399;
    }
  }

  .el-radio__label {
    color: #fff;
  }

  .el-form-item__label {
    color: #fff;
  }
}
</style>
